/* eslint-disable import/prefer-default-export */
import { m, mb } from '@upgrade/react-components/Spacing/core';
import { focusVisibleWithOutline } from '@upgrade/react-components/utils/focus-indicator';
import { Link } from 'gatsby';
import styled from 'styled-components';

export const StyledH4 = styled.div`
  &&& {
    font-size: ${({ theme }) => theme.typography.sizes.headings.desktop.xl.fontSize};
    line-height: 2.5rem;
    font-weight: 500;
    ${mb('xl')};
    color: ${({ 'data-color': dataColor, theme }) => theme.palette[dataColor] || theme.palette.content};
    @media (max-width: ${props => props.theme.mediaSm}) {
      font-size: ${({ theme }) => theme.typography.sizes.headings.desktop.xs.fontSize};
      line-height: 1.5rem;
    }
  }
`;

export const StyledH5 = styled.div`
  font-size: ${({ theme }) => theme.typography.sizes.headings.desktop.sm.fontSize};
  line-height: 2rem;
  font-weight: 500;
  color: ${({ 'data-color': dataColor, theme }) => theme.palette[dataColor] || theme.palette.content};
  text-align: ${({ textAlign }) => textAlign};
  @media (max-width: ${props => props.theme.mediaSm}) {
    font-size: ${({ theme }) => theme.typography.sizes.text.desktop.lg.fontSize};
    line-height: 1.5rem;
  }
`;

export const StyledH6 = styled.div`
  font-size: ${({ theme }) => theme.typography.sizes.headings.desktop.xs.fontSize};
  line-height: 1.5rem;
  font-weight: 500;
  color: ${({ 'data-color': dataColor, theme }) => theme.palette[dataColor] || theme.palette.content};
  ${mb('md')};
  @media (max-width: ${props => props.theme.mediaSm}) {
    font-size: ${({ theme }) => theme.typography.sizes.text.desktop.md.fontSize};
    line-height: 1.5rem;
  }
`;

export const StyledP = styled.p`
  font-size: ${({ theme }) => theme.typography.sizes.headings.desktop.xs.fontSize};
  line-height: 1.5rem;
  font-weight: 400;
  color: ${({ 'data-color': dataColor, theme }) => theme.palette[dataColor] || theme.palette.contentWeak};
  @media (max-width: ${props => props.theme.mediaSm}) {
    font-size: ${({ theme }) => theme.typography.sizes.text.desktop.md.fontSize};
    line-height: 1.75rem;
  }
`;

export const StyledBody = styled.div`
  font-size: ${({ theme }) => theme.typography.sizes.headings.desktop.xs.fontSize};
  line-height: 1.5rem;
  font-weight: 400;
  text-align: ${({ textAlign }) => textAlign};
  color: ${({ 'data-color': dataColor, theme }) => theme.palette[dataColor] || theme.palette.contentWeak};
  @media (max-width: ${props => props.theme.mediaSm}) {
    font-size: ${({ theme }) => theme.typography.sizes.text.desktop.md.fontSize};
    line-height: 1.75rem;
  }

  a.markdown-link {
    text-decoration: none;
    font-weight: 500;

    &:hover {
      text-decoration: underline;
    }

    ${focusVisibleWithOutline({ radius: 'default' })}
  }
`;

export const StyledBody2 = styled.div`
  font-size: ${({ theme }) => theme.typography.sizes.text.desktop.md.fontSize};
  line-height: 1.75rem;
  font-weight: 400;
  color: ${({ 'data-color': dataColor, theme }) => theme.palette[dataColor] || theme.palette.contentWeak};
  @media (max-width: ${props => props.theme.mediaSm}) {
    font-size: ${({ theme }) => theme.typography.sizes.text.desktop.xs.fontSize};
    line-height: 1rem;
  }
`;

export const StyledCaption = styled.div`
  ${m('none')};
  font-size: ${({ theme }) => theme.typography.sizes.text.desktop.xs.fontSize};
  line-height: 1.5rem;
  font-weight: 300;
  color: ${({ 'data-color': dataColor, theme }) => theme.palette[dataColor] || theme.palette.contentWeak};
  @media (max-width: ${props => props.theme.mediaSm}) {
    font-size: ${({ theme }) => theme.typography.sizes.text.desktop.xs.fontSize};
    line-height: 1rem;
  }
`;

export const StyledOverLine = styled.span`
  font-size: ${({ theme }) => theme.typography.sizes.text.desktop.xs.fontSize};
  line-height: 1.3rem;
  font-weight: 400;
  color: ${({ 'data-color': dataColor, theme }) => theme.palette[dataColor] || theme.palette.contentWeak};
  letter-spacing: 0.075rem;

  & > * {
    ${m('none')};
  }

  @media (max-width: ${props => props.theme.mediaSm}) {
    font-size: ${({ theme }) => theme.typography.sizes.text.desktop.xxs.fontSize};
    line-height: 1rem;
  }
`;

export const StyledLink = styled(Link)`
  color: ${({ 'data-color': dataColor, theme }) => theme.palette[dataColor] || theme.palette.actionablePrimary};
  font-weight: 500;
  display: inline-block;
  text-decoration: none;
  width: max-content !important;
  font-size: ${({ theme }) => theme.typography.sizes.headings.desktop.xs.fontSize};
  cursor: pointer;

  &:hover {
    text-decoration: none;
    color: ${props => props.theme.palette.actionableHover};
  }

  * {
    color: ${({ 'data-color': dataColor, theme }) => theme.palette[dataColor] || theme.palette.actionablePrimary};
  }

  ${focusVisibleWithOutline({ offset: 'default', radius: 'default' })}
`;

// TODO: I need to finish removing the unneeded headers from the upgrade-card code
